// extracted by mini-css-extract-plugin
export default {"logo":"StoryFileLogo_logo__pNkUx","smallText":"StoryFileLogo_smallText__vWm-t","noMargin":"StoryFileLogo_noMargin__ivmBs"};